module.exports = __webpack_public_path__ + "img/symbol_1.f5e0e9ca.png";